"use strict";
/* tslint:disable */
var load_themed_styles_1 = require("@microsoft/load-themed-styles");
load_themed_styles_1.loadStyles([{ "rawString": ".ms-Icon-imageContainer{overflow:hidden}.ms-Icon-Image{position:relative}" }]);
/* tslint:enable */ 

//# sourceMappingURL=Icon.scss.js.map



//////////////////
// WEBPACK FOOTER
// ../components/Icon/Icon.scss.js
// module id = 53
// module chunks = 0